import React from 'react';
import Vacancy from './Vacancy'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Button } from 'antd';
import usePortalService from '../../services/PortalService';
import { ReplyButton } from '../../Components/ReplyButton';
import { RegistrationIsRequired } from '../../Components/Modals';
import { Vacancy as VacancyType } from '../../types';
import { NotAuthorizedNavbar } from '../../Components/Navbars';

let vacancyId: string;
export const VacancyNotAuthorized = () => {
    const { getVacancyById } = usePortalService();

    const params = useParams();
    vacancyId = params.id as string;
    const [vacancy, setVacancy] = useState<VacancyType>();
    const [error, setError] = useState();

    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        getVacancyById(vacancyId)  
        .then(result => {
            if (result.success){
                setVacancy(result.vacancy)
            } else {
                setError(result.errors)
            }
        });
    }, []);

    const showModal = () => {
        setIsModalOpen(true);
    }

    const closeHandler = () => {
        setIsModalOpen(false);
    }

    return (
        <>
            <NotAuthorizedNavbar />
            {
                vacancy ? 
                <Vacancy vacancy={vacancy} userRole={"profile"}>
                    {(vacancy.status !== "В архиве" ) && 
                    <Button type="primary" onClick={showModal} style={{width:'173px', marginBottom:'32px'}} >Откликнуться</Button>}
                </Vacancy> :
                <p style={{paddingTop:'100px', paddingLeft: '150px'}}> {error} </p>
            }
            <RegistrationIsRequired isOpen={isModalOpen} close={closeHandler}/>
        </>
    );
}